module.exports = __webpack_public_path__ + "static/IMG_7885-2d99a54f5805738d4efcd7b9c134595c.jpg";